<template>
	<div class="page">
		<NavBar
			title="订单详情"
			:right-text="statusText"
			left-arrow
			@click-left="onClickLeft"
		/>
		<div class="order-card">
      <Cell>
        <div class="good-box" v-for="(subItem, subIndex) in target.goodList" :key="subIndex">
				  <VanImage
					  width="3rem"
					  height="3rem"
					  style="margin-right: 15px; margin-top: 5px"
					  :src="subItem.goodsImages[0].imageUrl"/>
				  <div class="right">
					  <p class="title">{{ subItem.goodsInfo.goodsName }}</p>
					  <p class="text"><span>监管价格：{{ subItem.goodsInfo.price }} /天</span></p>
					  <p class="text">x {{ subItem.orderBillDetail.goodsNum }}</p>
				  </div>
	         <p class="text" style="position: absolute; bottom: 0; right: 0">总价：￥ {{ target.price }} 元</p>
			  </div>
      </Cell>
      <div class="order-card-footer" v-if="target.status === 0">
        <Button class="item" size="small" @click="onCancelClick(target)">取消订单</Button>
        <Button class="item" size="small" type="danger" plain @click="onBuyClick(target)">继续付款</Button>
      </div>
    </div>
		<div class="split"></div>
		<CellGroup>
		  <Cell title="订单编号" :value="target.orderNo" />
		  <Cell title="微信交易号" :value="target.wxOrder" />
		  <Cell title="创建时间" :value="target.createTime" />
		  <Cell title="付款时间" :value="target.payTime" />
		</CellGroup>
	</div>
</template>

<script>
	import {  NavBar, Image as VanImage, Cell, CellGroup, Button, ActionSheet  } from 'vant';
	export default {
    components: {NavBar, VanImage, Cell, CellGroup, Button, ActionSheet },
	  data() {
	    return {
	      target: {}
	    }
	  },
		computed: {
      statusText() {
        switch (this.target.status) {
	        case 0:
	          return '未支付'
          case 1:
            return '已支付'
          case 2:
            return '过期'
          case 3:
            return '服务到期'
        }
      }
		},
    created() {
      this.target = this.$route.params;
		},
		methods: {
      onClickLeft () {
        this.$router.back()
      },
      async onCancelClick(target) {
        try {
          await this.$store.dispatch('cancelOrder', { orderId: target.id })
        } catch {}
      },
      onBuyClick(target) {
        this.$store.dispatch('handlePay', { orderId: target.id })
          .then(data => {
          })
      },
		}
	}
</script>

<style lang="less" scoped>
	.fixed-top {
		position: fixed;
		top: 46px;
		left: 0;
		right: 0;
		z-index: 2;
	}
	.page {
		height: 100%;
		background-color: #f5f5f5;
	}
	.order-card {
		overflow: hidden;
		background-color: #fff;

		&-footer {
			padding: 10px 16px;
			display: flex;
			align-items: center;
			justify-content: flex-end;
			font-size: 12px;

			.item {
				margin: 0 6px;
			}

			.text {
				color: #666;
			}
		}
	}
</style>
